import { graphql, readInlineData } from 'react-relay';
import { trackNonStandardAbTest } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

import { type trackSeoTests_abTestConfigV2UserVariant$key } from './__generated__/trackSeoTests_abTestConfigV2UserVariant.graphql.ts';

const seoAbTestV2ListFragment = graphql`
    fragment trackSeoTests_abTestConfigV2UserVariant on AbTestConfigV2UserVariant @inline {
        variant
        config {
            testName
        }
    }
`;

const trackedTests = new Set<string>();

export const trackSeoTests = ({
    seoAbTestV2List: seoAbTestV2ListRef,
}: {
    seoAbTestV2List:
        | ReadonlyArray<trackSeoTests_abTestConfigV2UserVariant$key | null | undefined>
        | null
        | undefined;
}): void => {
    const abTestV2List = (seoAbTestV2ListRef || []).map(ref =>
        readInlineData(seoAbTestV2ListFragment, ref)
    );

    for (const abTestV2 of abTestV2List) {
        const testName = abTestV2?.config?.testName ?? undefined;
        const variant = abTestV2?.variant ?? undefined;

        if (variant && testName && !trackedTests.has(testName)) {
            trackNonStandardAbTest({ testName, variant });
            trackedTests.add(testName);
        }
    }
};
